import { Divider, IconButton, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useSelector } from 'react-redux'
import { UtilityDetailSelector } from '../../../../store/utilityDetails'
import { CustomButton, OutlinedButton } from '../../../Button'
import { CloseIcon } from '../../../icons/CloseIcon'
import { WarningIcon } from '../../../icons/WarningIcon'
import InfoBannerWidget from './components/InfoBannerWidget'
import ProbabilityInfoWidget from './components/ProbabilityInfoWidget'
import { useNavigate } from 'react-router'

interface WellUtilityDetailProps {
  onClose: (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => void
}

export const WellUtilityDetail: React.FC<WellUtilityDetailProps> = ({ onClose }) => {
  const { GEOID_BlkGrp, State, HU_2020, Est_Wells_2020,Prob_Pub } = useSelector(UtilityDetailSelector.getWellUtilityData)
  const navigate = useNavigate()

  return (
    <Stack gap={2}>
      <Stack gap={2} sx={{ mb: 2 }}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center">
          <Typography
            fontSize="1.125rem"
            color="text.secondary"
            fontWeight="bold"
            sx={{ marginRight: '4px' }}
          >
            Block group:
          </Typography>
          <Typography fontSize="1.125rem" color="primary.dark" fontWeight="bold">
            {GEOID_BlkGrp}
          </Typography>
          <IconButton onClick={onClose} aria-label="close" sx={{ marginLeft: 'auto' }}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider />
        <Grid size={6}>
          <Stack sx={{ mb: 2 }}>
            <Typography color="text.secondary" fontSize={14} fontWeight={500}>
              Location
            </Typography>
            <Typography fontSize="1rem" color="primary.dark" fontWeight={600}>
             {State}
            </Typography>
          </Stack>
          <ProbabilityInfoWidget probability={Prob_Pub} estimatedWells={Est_Wells_2020}/>
        </Grid>
        
        <Grid container spacing={2}>
        <Stack sx={{ mt: 0, mb: -1 }}> 
        <Typography color="text.secondary" fontSize={14} fontWeight={500}>
              Housing units in the area
            </Typography>
            <Typography fontSize="1rem" color="primary.dark" fontWeight={600}>
              {HU_2020}
            </Typography>
            </Stack>
            <InfoBannerWidget
            type="warning"
            message="Well water systems are unregulated, we do not have direct water quality information. We strongly recommend having your well tested as soon as possible (and regularly thereafter) to ensure safe drinking water."
            icon={<WarningIcon />}
          />
          <InfoBannerWidget
            type="info"
            message="The SIPP system comprehensively treats your water for maximum protection. Check out the table above to see how the specific contaminants are handled by SIPP."
          />
          <CustomButton fullWidth onClick={() => navigate('/test-strip')}  text="Request a water quality test strip" />
        </Grid>
      </Stack>
    </Stack>
  )
}
